import React, { useEffect, useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap';
import FinancesTransactionSelectionTable from './controls/FinancesTransactionSelectionTable';

function FinancesMatchWithdrawals() {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await fetch('api/finances/getwithdrawalsunmatched');
      const data = await response.json();
      setData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const [open, setOpen] = useState('1');
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div>
      <div>
        <h2>Match Withdrawals and Sales (
          {data?.reduce((total, symbolGroup) => total + symbolGroup.assets.filter(t => t.type === "WITHDRAWAL").length, 0)}W,
          {data?.reduce((total, symbolGroup) => total + symbolGroup.assets.filter(t => t.type === "SELL").length, 0)}S) ({data?.length})</h2>
        <br></br>
        <br></br>
        {data?.map((symbolGroup, index) => {
          const unmatchedWithdrawals = symbolGroup.assets.filter(t => t.type === "WITHDRAWAL").length;
          const unmatchedSales = symbolGroup.assets.filter(t => t.type === "SELL").length;
          return (
            <Accordion open={open} toggle={toggle} stayopen>
              <AccordionItem targetId={symbolGroup.symbol + index.toString()}>
                <AccordionHeader targetId={symbolGroup.symbol + index.toString()}>
                  <h5>{symbolGroup.accountName} <b>[{symbolGroup.symbol}]</b> ({unmatchedWithdrawals}W, {unmatchedSales}S)</h5>
                </AccordionHeader>
                <AccordionBody accordionId={symbolGroup.symbol + index.toString()}>
                  <FinancesTransactionSelectionTable
                    transactions={symbolGroup?.assets}
                    matchUrl={'api/finances/matchtransactions'}
                    getData={getData} />
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
}

export default FinancesMatchWithdrawals;